import { render } from "./InputRequiredTextArea.vue?vue&type=template&id=1328ff9c&scoped=true"
import script from "./InputRequiredTextArea.vue?vue&type=script&lang=js"
export * from "./InputRequiredTextArea.vue?vue&type=script&lang=js"

import "./InputRequiredTextArea.vue?vue&type=style&index=0&id=1328ff9c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3368519796/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1328ff9c"]])

export default __exports__